function getCenteredWindowParams() {
    const width = 400
    const height = 600
    const left = window.screenX + (window.innerWidth - width) / 2
    const top = window.screenY + (window.innerHeight - height) / 2

    return `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`
}

/**
 * Opens a new window using the current URL. This retains the same origin so we have programmatic access
 * to that window's contents. We immediately replace the content of the window with a message.
 *
 * @returns {array} holding references to the new window and a callback that when called with a URL will
 * navigate the window to the new URL and focus the window immediately.
 */
export function createPopup(): [Window, (url: string) => Window | null] {
    const windowParams = getCenteredWindowParams()
    const myWindow = window.open(window.location.href, "/id:popup", windowParams)

    if (!myWindow) {
        // TODO standardise error handling
        throw new Error("SlashId: Popup blocked, please consider redirect instead")
    }

    const redirectMessage =
        '<div style="position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);">You will be redirected in a moment...</div>'
    try {
        myWindow?.document?.write(redirectMessage)
    } catch (e) {
        console.error(e)
        if (myWindow.document && myWindow.document.body) {
            myWindow.document.body.innerHTML = redirectMessage
        }
    } finally {
        myWindow.blur()
    }

    const setWindowUrl = (url: string) => {
        if (myWindow) {
            myWindow.location = url
            myWindow.focus()
        }
        return myWindow
    }

    return [myWindow, setWindowUrl]
}
